import { useSearchParams } from "react-router-dom";
import GrowthLeads from "./GrowthLeads";
import { GrowthCampaigns, GrowthContent, GrowthPartners, GrowthResults } from "./GrowthEngineTabs";
import { Rocket, Users, Megaphone, FileText, Handshake, BarChart3 } from "lucide-react";

const SUB = [["leads", "Leads", Users], ["campaigns", "Campaigns", Megaphone], ["content", "Content", FileText], ["partners", "Partners", Handshake], ["results", "Results", BarChart3]];

export default function GrowthEngine() {
  const [sp, setSp] = useSearchParams(); const sub = sp.get("sub") || "leads";
  const go = (v) => setSp(sp.get("tab") ? { tab: sp.get("tab"), sub: v } : { sub: v });
  return (
    <section className="space-y-5" data-testid="growth-engine">
      <div><p className="font-mono text-xs tracking-widest uppercase text-cyan-400">// Velocity Growth Engine</p><h2 className="font-display text-2xl font-bold flex items-center gap-2"><Rocket className="w-5 h-5 text-cyan-400" />Capture → convert → measure</h2><p className="text-xs text-slate-400 mt-1">Driver inquiries (/drivers) and host applications (/hosts) with source attribution · $5,000/mo planning budget · conversions tracked separately: first completed rental vs. activated vehicle.</p></div>
      <div className="flex flex-wrap gap-2">{SUB.map(([v, l, I]) => <button key={v} onClick={() => go(v)} className={`h-9 px-4 rounded-full border text-sm inline-flex items-center gap-2 ${sub === v ? "bg-cyan-400 text-slate-950 border-cyan-400 font-semibold" : "border-slate-700 text-slate-300 hover:border-cyan-400/50"}`} data-testid={`engine-sub-${v}`}><I className="w-4 h-4" />{l}</button>)}</div>
      {sub === "leads" && <GrowthLeads />}
      {sub === "campaigns" && <GrowthCampaigns />}
      {sub === "content" && <GrowthContent />}
      {sub === "partners" && <GrowthPartners />}
      {sub === "results" && <GrowthResults />}
    </section>
  );
}
